export const ADD_PERSONAL_INFO = 'ADD_PERSONAL_INFO';
export const SET_SINISTER_LIST = 'SET_SINISTER_LIST';
export const INCREMENT_STEP = 'INCREMENT_STEP';
export const REDUCE_STEP = 'REDUCE_STEP';
export const SET_STEP = 'SET_STEP';
export const INCREMENT_SINISTER = 'INCREMENT_SINISTER';
export const REDUCE_SINISTER = 'REDUCE_SINISTER';
export const SET_SINISTER = 'SET_SINISTER';
export const UPDATE_SINISTER_LIST = 'UPDATE_SINISTER_LIST';
export const STORE_NEW_FILES = 'STORE_NEW_FILES';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';
export const REMOVE_SINISTER = 'REMOVE_SINISTER';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_OTHER_INSURANCE = 'SET_OTHER_INSURANCE';
export const DELETE_FILES = 'DELETE_FILES';
export const SET_SINISTER_DATE = 'SET_SINISTER_DATE';
export const SET_SINISTER_NUMBER_CASE = 'SET_SINISTER_NUMBER_CASE';
export const RESET_STATE = 'RESET_STATE';
export const SET_OTHER_DESCRIPTION = 'SET_OTHER_DESCRIPTION';
export const SET_ADVISOR_INFO = 'SET_ADVISOR_INFO';
export const SET_STORE_FILES = 'SET_STORE_FILES';